export enum ActionType {
    SET_MAP_READY = 'SET_MAP_READY',
    SET_AGENCY = 'SET_AGENCY',
    SET_DATE_TIME = 'SET_DATE_TIME',
    SET_ROUTES_STATE = 'SET_ROUTES_STATE',
    SET_DIRECTIONS_STATE = 'SET_DIRECTIONS_STATE',
    SET_STOPS_STATE = 'SET_STOPS_STATE',
    SET_STOP_SEARCH_STATE = 'SET_STOP_SEARCH_STATE',
    SET_NO_STOPS_MESSSAGE = 'SET_NO_STOPS_MESSSAGE',
    SET_DIRECTIONS_INFO = 'SET_DIRECTIONS_INFO',
    SET_STOPS_PREDICTIONS = 'SET_STOPS_PREDICTIONS',
    SET_BUS_POSITIONS = 'SET_BUS_POSITIONS',
    SET_SCHEDULE_DATES = 'SET_SCHEDULE_DATES',
    SET_SLIDER_OPTIONS = 'SET_SLIDER_OPTIONS',
    SET_SLIDER_INFO = 'SET_SLIDER_INFO',
    SET_ROUTES_LOADING = 'SET_ROUTES_LOADING',
    SET_DIRECTIONS_LOADING = 'SET_DIRECTIONS_LOADING',
    SET_HISTORY_LOADING = 'SET_HISTORY_LOADING',
    SET_VEHICLES = 'SET_VEHICLES',
    DISPLY_DIRECTION_STOPS = 'DISPLY_DIRECTION_STOPS',
    SET_STOPS_LOADING = 'SET_STOPS_LOADING',
    SET_MAP_BOUNDS = 'SET_MAP_BOUNDS',
    SET_URL_FILTERS_STATE = 'SET_URL_FILTERS_STATE',
}

export type BusPositionHistoryAction = {
    type: ActionType;
    payload?: any;
};
